export enum Tab {
    Mail = 'mail',
    OTP = 'oneTimePin',
    Password = 'password'
}